import { render, staticRenderFns } from "./bstructure.vue?vue&type=template&id=ca21eb7c&scoped=true&"
import script from "./bstructure.vue?vue&type=script&lang=js&"
export * from "./bstructure.vue?vue&type=script&lang=js&"
import style0 from "./bstructure.vue?vue&type=style&index=0&id=ca21eb7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca21eb7c",
  null
  
)

export default component.exports